(function () {
  if ($pdk && $pdk.controller && $pdk.controller.plugInLoaded) {
    var youboraPlugin = function () {
      var VERSION = "1.0"

      /**
       * Initialize the plugin with the load object
       * @param lo load object
       */
      function initialize (lo) {
        if (lo.vars.accountCode) {
          var options = { accountCode: lo.vars.accountCode, extraParams: {} }
          if (lo.vars.extraparams) {
            var paramlist = lo.vars.extraparams.split(',')
            for (var i = 0; i < paramlist.length; i++) {
              options.extraParams['param' + (i + 1)] = paramlist[i]
            }
          }
          if (lo.vars.scope) {
            options.scope = lo.vars.scope
          }
          window.youboraAnalytics = new youbora.Plugin({ accountCode: lo.vars.accountCode });
          youboraAnalytics.setAdapter(new youbora.adapters.ThePlatform(lo.controller, options))
        }
      }
      this.initialize = initialize
    }
    $pdk.controller.plugInLoaded(new youboraPlugin(), null)
  }
})();
